import "./index.scss";
import "../CategorySelect/index.scss"; // the shared level dots
import "../index.scss";
import PropTypes from "prop-types";
import { displayGameName, fetchImage } from "../../nonUIFuncs";

const GameSelect = (props) => {
  return (
    <div className="EM-GS-container">
      <div className="EM-topBanner">
        <div className="EM-topBanner-inner">Choose A Game</div>
      </div>

      <div className="EM-container em2_games">
        {props.games.map((datum) => {
          let gameSpecLvlData = props.levelData.filter(
            (game) => game.spreadGameType === datum
          );
          let bestEasy = gameSpecLvlData[0];
          let bestMedium = gameSpecLvlData[0];
          let bestHard = gameSpecLvlData[0];
          if (gameSpecLvlData.length === 0) {
            return null;
          }
          gameSpecLvlData.forEach((game) => {
            if (game.levelEasy > bestEasy.levelEasy) {
              bestEasy = game;
            }
            if (game.levelMedium > bestMedium.levelMedium) {
              bestMedium = game;
            }
            if (game.levelHard > bestHard.levelHard) {
              bestHard = game;
            }
          });
          let gameImg = datum.replaceAll("-", "_").replaceAll(" ", "_");
          let image = `Game_Type_${gameImg}2x.png`;
          const best = [
            ["e", bestEasy.levelEasy],
            ["m", bestMedium.levelMedium],
            ["h", bestHard.levelHard],
          ];
          return (
            <button
              type="button"
              id={datum}
              className="em2_game"
              style={{ "--order": props.games.indexOf(datum) }}
              onClick={() => props.findCategories(datum)}
              key={datum}
              aria-label={`Select game: ${displayGameName(datum)}`}
            >
              <span className="em2_gameBadge" style={{ backgroundImage: `url(${fetchImage(image)})` }} />
              <span className="em2_gameName badaBoom">{displayGameName(datum)}</span>
              <span className="em2_gameBest" aria-hidden="true">
                <span className="em2_bestLabel">Best</span>
                {best.map(([k, lvl]) => (
                  <span key={k} className={`em2_lvl em2_lvl--${k}`}>
                    {lvl}
                  </span>
                ))}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GameSelect;

GameSelect.propTypes = {
  findCategories: PropTypes.func,
  games: PropTypes.array,
  levelData: PropTypes.array,
};
